import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import HotTopics from '@/pages/home/components/HotTopics';
import LatestNews from '@/pages/home/components/LatestNews';
import CategorySection from '@/pages/home/components/CategorySection';
import DailyContest from '@/pages/home/components/DailyContest';
import CTASection from '@/pages/home/components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotTopics />
        <LatestNews />
        <CategorySection />
        <DailyContest />
        <CTASection />
      </main>
      <Footer />

      {/* Schema.org WebSite */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '今日吃瓜',
            url: 'http://shcfugs.cn/',
            description: '今日吃瓜首页聚合页，聚焦51今日吃瓜、黑料网、每日大赛等高搜索量热词，提供网红爆料、在线观看、热门大瓜等实时吃瓜内容。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'http://shcfugs.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '今日吃瓜',
            url: 'http://shcfugs.cn/',
            description: '今日吃瓜 - 中国领先的娱乐八卦新闻聚合平台',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-6666',
              contactType: 'customer service',
              email: 'hello@shcfugs.cn',
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: '望京SOHO T1 B座 18层 1808室',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              addressCountry: 'CN',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '今日吃瓜 - 首页',
            url: 'http://shcfugs.cn/',
            description: '今日吃瓜首页聚合页，聚焦51今日吃瓜、黑料网、每日大赛等高搜索量热词，提供网红爆料、在线观看、热门大瓜等实时吃瓜内容。',
            isPartOf: {
              '@type': 'WebSite',
              name: '今日吃瓜',
              url: 'http://shcfugs.cn/',
            },
          }),
        }}
      />
    </>
  );
}